/**
 * Build process parameters captured in the "Configure Production Build Process" modal
 * (Target Setup Time, Resin Change, Die Shot Req, Operator Name).
 */
export const RESIN_CHANGE_OPTIONS = [
  { value: 'plan', label: 'Plan' },
  { value: 'mix', label: 'Mix' }
];

export const EMPTY_PROCESS_SPECS = {
  targetSetupTimeSec: '',
  resinChange: '',
  dieShotReq: '',
  operatorName: ''
};

const hasValue = (v) => v !== undefined && v !== null && v !== '';

// Form state for the build modal, pre-filled from an existing job (edit mode)
export const processSpecsFromJob = (job) => ({
  targetSetupTimeSec: hasValue(job?.targetSetupTimeSec) ? String(job.targetSetupTimeSec) : '',
  resinChange: job?.resinChange || '',
  dieShotReq: hasValue(job?.dieShotReq) ? String(job.dieShotReq) : '',
  operatorName: job?.operatorName || ''
});

// API payload: numbers as numbers, blanks as null so a cleared field is saved as empty
export const processSpecsToPayload = (specs) => ({
  targetSetupTimeSec: hasValue(specs.targetSetupTimeSec) ? Number(specs.targetSetupTimeSec) : null,
  resinChange: specs.resinChange || '',
  dieShotReq: hasValue(specs.dieShotReq) ? Number(specs.dieShotReq) : null,
  operatorName: (specs.operatorName || '').trim()
});

// Display rows for whatever has been filled in on a build job
export const getBuildProcessSpecs = (job) => {
  if (!job) return [];
  const specs = [];
  if (job.operatorName) specs.push({ label: 'Operator', value: job.operatorName });
  if (hasValue(job.targetSetupTimeSec)) specs.push({ label: 'Target Setup Time', value: `${job.targetSetupTimeSec} sec` });
  if (job.resinChange) {
    const opt = RESIN_CHANGE_OPTIONS.find(o => o.value === job.resinChange);
    specs.push({ label: 'Resin Change', value: opt ? opt.label : job.resinChange });
  }
  if (hasValue(job.dieShotReq)) specs.push({ label: 'Die Shot Req', value: job.dieShotReq });
  return specs;
};

export const formatBuildProcessSpecs = (job, separator = ' | ') =>
  getBuildProcessSpecs(job).map(s => `${s.label}: ${s.value}`).join(separator);
